"use client";

import React from "react";
import { Phone, ArrowRight, ShieldCheck, Clock } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
export default function Emergency() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="emergencycalltoaction" data-nav="light" className="bg-background py-16 md:py-24 border-t border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="relative overflow-hidden rounded-2xl border border-border bg-muted/40 p-8 sm:p-12 lg:p-16 shadow-sm">
          <div className="relative z-10 max-w-3xl mx-auto text-center space-y-6">
            <div className="flex flex-wrap items-center justify-center gap-2">
              <Badge variant="outline" className="border-primary/30 bg-background text-primary px-3 py-1 font-medium">
                <Clock className="size-3.5" />
                24/7 emergency dispatch
              </Badge>
              <Badge variant="outline" className="border-border bg-background text-muted-foreground px-3 py-1 font-medium">
                <ShieldCheck className="size-3.5" />
                Direct local crews
              </Badge>
            </div>

            <h2 className="text-3xl sm:text-4xl md:text-5xl font-default font-bold text-foreground tracking-tight">
              Need immediate restoration help?
            </h2>

            <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed">
              Speak directly with local technicians stationed across Maryland, Washington, D.C., and Northern Virginia. We coordinate directly with your insurance from the initial call.
            </p>

            <div className="pt-2 flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button asChild size="lg" className="w-full sm:w-auto h-12 px-8 text-base font-semibold bg-primary text-primary-foreground hover:bg-primary/90 shadow-md transition-colors">
                <a href="tel:8554356631">
                  <Phone className="size-4" />
                  Call 855-435-6631
                </a>
              </Button>

              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto h-12 px-8 text-base font-semibold border-border bg-background text-foreground hover:bg-muted transition-colors">
                <Link to="/ContactRequestServicePage">
                  Request Service
                  <ArrowRight className="size-4" />
                </Link>
              </Button>
            </div>

            <p className="text-xs text-muted-foreground pt-2">
              Zero call centers. Direct communication with your local response team.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}